// extracted by mini-css-extract-plugin
export default {"constructionInfoItem":"IsaacPill_constructionInfoItem__hL-Ay","itemKey":"IsaacPill_itemKey__epADK","itemValue":"IsaacPill_itemValue__J0qqz"};